import { render } from "./MedicalSpecialists.vue?vue&type=template&id=2447dc5e&scoped=true"
import script from "./MedicalSpecialists.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialists.vue?vue&type=script&lang=js"

import "./MedicalSpecialists.vue?vue&type=style&index=0&id=2447dc5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2447dc5e"]])

export default __exports__